package one.healthium.events

import one.healthium.domain.user.UserEvent
import one.healthium.domain.user.UserEvents
import one.healthium.ui.common.event_producer.EventProducer

class UserEventsChannel : UserEvents {

    val events = EventProducer<UserEvent>()

    override suspend fun onWaterIntakeAdded(taskId: String?) {
        events.trigger(UserEvent.WaterIntakeAdded(taskId))
    }

    override suspend fun onWeightUpdated(taskId: String?) {
        events.trigger(UserEvent.WeightUpdated(taskId))
    }

    override suspend fun onFoodAdded(taskId: String?) {
        events.trigger(UserEvent.FoodAdded(taskId))
    }

    override suspend fun onSymptomsAdded(taskId: String?) {
        events.trigger(UserEvent.SymptomsAdded(taskId))
    }

    override suspend fun onHealthLogAdded(taskId: String?) {
        events.trigger(UserEvent.HealthLogAdded(taskId))
    }
}